import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useFormikContext } from 'formik';
import propTypes from 'prop-types';

function SubmitBtn({ label, variant, color }) {
  const { isSubmitting } = useFormikContext();

  return (
    <Box>
      <Button
        variant={variant}
        color={color}
        type="submit"
        startIcon={isSubmitting ? <CircularProgress size={20} /> : undefined}
        disabled={isSubmitting}
      >
        {isSubmitting ? 'Loading...' : label}
      </Button>
    </Box>
  );
}

SubmitBtn.propTypes = {
  label: propTypes.string,
  variant: propTypes.string,
  color: propTypes.string,
};

SubmitBtn.defaultProps = {
  label: 'Submit',
  variant: 'contained',
  color: 'primary',
};

export default SubmitBtn;
